import { render, staticRenderFns } from "./MaterialStatsCardNF.vue?vue&type=template&id=cb7c8464&scoped=true"
import script from "./MaterialStatsCardNF.vue?vue&type=script&lang=js"
export * from "./MaterialStatsCardNF.vue?vue&type=script&lang=js"
import style0 from "./MaterialStatsCardNF.vue?vue&type=style&index=0&id=cb7c8464&prod&scoped=true&lang=css"
import style1 from "./MaterialStatsCardNF.vue?vue&type=style&index=1&id=cb7c8464&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7c8464",
  null
  
)

export default component.exports